import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { history } from '../store'
import AppTimeHeader from '../containers/AppTimeHeader'
import { withNamespaces } from "react-i18next"
import { fetchTimeAvailability } from '../actions/qrstime'
import StepBarTime from '../components/StepBarTime'
import { MapPin } from 'lucide-react'

class ZoneSelectorTimeView extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      zones: null,
      description: null,
      customerName: null,
      timeConfig: null,
      forwardScreen: false,
      machineSleeping: false
    }
  }

  getButtonStyle() {
    const { qrData } = this.props;
    const buttonColor1 = qrData?.headerConfig?.buttonColor1 || '#01315f';
    const buttonColor2 = qrData?.headerConfig?.buttonColor2 || '#067ddb';
    const buttonText = qrData?.headerConfig?.buttonText || '#ffffff';

    return {
      background: `linear-gradient(135deg, ${buttonColor1}, ${buttonColor2})`,
      color: buttonText,
      border: 'none'
    };
  }

  getIconColor() {
    const { qrData } = this.props;
    return qrData?.headerConfig?.iconsColor || '#01315f';
  }

  goTo = (zoneNumber, descriptionZone, timeConfigOverride) => {
    const { id } = this.props.match.params;
    const { qrMode } = this.props.location.state;

    this.setState({ forwardScreen: true }, () => {
      history.push('/lockerSelectorTimeView', {
        zoneSelected: zoneNumber,
        descriptionZone: descriptionZone,
        qr: id,
        customerName: this.state.customerName,
        qrMode: qrMode,
        timeConfig: timeConfigOverride !== undefined ? timeConfigOverride : this.state.timeConfig,
      });
    });
  }

  componentDidMount() {
    const { id } = this.props.match.params;

    // Check sleeping hours
    const now = new Date();
    const spainTime = new Intl.DateTimeFormat('en-US', {
      timeZone: 'Europe/Madrid',
      hour: 'numeric',
      hour12: false,
    }).formatToParts(now);

    const hour = parseInt(spainTime.find(part => part.type === 'hour').value, 10);

    if (hour === 23 || hour === 0) {
      this.setState({ machineSleeping: true });
      return;
    }

    this.props.fetchTimeAvailability(id)
      .then((answer) => {
        const answerZones = answer.response.answerZones;
        const timeConfig = answer.response.timeConfig;
        const customerName = answerZones.customerName;

        this.setState({ customerName, timeConfig });

        if (answerZones.multipleZones && answerZones.multipleZones.length > 0) {
          this.setState({
            zones: answerZones.multipleZones,
            description: answerZones.descriptionZones,
          });
        } else if (answerZones.singleZone != null) {
          // Pass timeConfig and customerName directly — state may not have updated yet
          this.setState({ customerName }, () => {
            this.goTo(answerZones.singleZone, answerZones.descriptionZones[(answerZones.singleZone) - 1], timeConfig);
          });
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  renderSleepingMessage() {
    const { t } = this.props;

    return (
      <div className="timeBackground">
        <AppTimeHeader />
        <div className="time-page-wrap">
          <div className="time-sleeping">
            <h3 className="text-warning">{t('Fuera de horario')}</h3>
            <p>{t('Lo sentimos, pero la venta no está disponible entre las 23:00h y la 01:00h, vuelva fuera de este horario.')}</p>
            <img src="/images/sleeping_machine.webp" alt="Sleeping Machine" className="time-sleeping-img" />
          </div>
        </div>
        <StepBarTime step={1} />
      </div>
    );
  }

  renderZones() {
    const { t } = this.props;
    const { zones, description } = this.state;
    const buttonStyle = this.getButtonStyle();
    const iconsColor = this.getIconColor();
    const buttonText = this.props.qrData?.headerConfig?.buttonText || '#ffffff';

    if (!zones || !description) {
      return (<div className="spinner"><img src="/images/logo.png" alt="Logo" /></div>)
    }

    return (
      <div className="time-zones-list">
        {zones.filter(zone => Number(zone) !== 0).sort((a, b) => a - b).map((zone) => (
          <div className="time-zone-card" key={zone} style={buttonStyle} onClick={() => this.goTo(zone, description[zone - 1])}>
            <div className="time-zone-icon">
              <img src="/images/PingRental.svg" alt={"Zona " + zone}
                style={{ filter: `drop-shadow(0 0 5px ${iconsColor})` }} />
            </div>
            <div className="time-zone-info">
              <h5 style={{ color: buttonText }}>{t('ZONA ') + zone}</h5>
              <p style={{ color: buttonText }}>{t(description[zone - 1])}</p>
            </div>
            <div className="time-zone-arrow">
              <span style={{ color: buttonText }}>›</span>
            </div>
          </div>
        ))}
      </div>
    );
  }

  render() {
    const { t } = this.props;
    const { customerName, machineSleeping } = this.state;

    if (machineSleeping) {
      return this.renderSleepingMessage();
    }

    return (
      <div className="timeBackground">
        <AppTimeHeader />
        <div className="time-page-wrap">
          <div className="time-content time-locker-selector-wide">
            <div className="time-page-header">
              <div className="time-page-header-icon" style={this.getButtonStyle()}>
                <MapPin size={24} strokeWidth={2} />
              </div>
              <div className="time-page-header-text">
                <h2>{customerName}</h2>
                <p>{t('Selecciona la zona de taquillas')}</p>
              </div>
              <span className="time-page-header-step">1 / 5</span>
            </div>

            {this.renderZones()}
          </div>
        </div>
        <StepBarTime step={1} />
      </div>
    )
  }
}

const mapStateToProps = state => ({
  auth: true,
  qrData: state.qrs.qr
})

const mapDispatchToProps = dispatch => ({
  push: bindActionCreators(push, dispatch),
  fetchTimeAvailability: bindActionCreators(fetchTimeAvailability, dispatch),
})

export default withNamespaces()(connect(mapStateToProps, mapDispatchToProps)(ZoneSelectorTimeView));
